/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_item = {
    readonly holidayShippingEstimations?: {
        readonly displayMessage: string | null;
        readonly termsAndConditions: string | null;
        readonly validHolidayShippingDays: ReadonlyArray<{
            readonly shipmentQuoteId: string | null;
            readonly estimatedDeliveryDay: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedShippingHolidayDelivery_item";
};
export type PdpSharedShippingHolidayDelivery_item$data = PdpSharedShippingHolidayDelivery_item;
export type PdpSharedShippingHolidayDelivery_item$key = {
    readonly " $data"?: PdpSharedShippingHolidayDelivery_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingHolidayDelivery_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "timezoneOffset"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingHolidayDelivery_item",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "timezoneOffset",
              "variableName": "timezoneOffset"
            }
          ],
          "concreteType": "HolidayShippingEstimationsType",
          "kind": "LinkedField",
          "name": "holidayShippingEstimations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "termsAndConditions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ValidHolidayShippingDays",
              "kind": "LinkedField",
              "name": "validHolidayShippingDays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shipmentQuoteId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimatedDeliveryDay",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '4af1b4bdb98f72466f0e63391ce9c0d8';
export default node;
